module.exports = __webpack_public_path__ + "img/img_coupon@2x.ecd62654.png";